import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { b2bPageData, b2bFAQs } from "./b2bdata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForB2BMarketplace() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="B2B Marketplace — AI-Powered Digital Trading Platform"
        description="EkkBaz AI's B2B Marketplace connects buyers and suppliers in an intelligent digital trading platform — with real-time pricing intelligence, automated procurement workflows, and AI-powered deal recommendations that grow revenue 50% faster."
        keywords="B2B marketplace platform, digital B2B trading, B2B procurement marketplace, AI B2B marketplace, supplier buyer platform, wholesale marketplace software, B2B e-commerce"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/b2b`}
        productName="B2B Marketplace"
        faqItems={b2bFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="B2B Marketplace"
        subtitle="Connect buyers and suppliers in an AI-powered digital marketplace. Real-time pricing intelligence, automated ordering, and 50% faster revenue growth."
        from="b2b"
      />
      <EnhancedPageLayout {...b2bPageData} />
      <UpdateFooter />
    </div>
  );
}
